import { IconProvider } from '../providers/iconProvider';
import { AsyncAction } from '../../base-classes/asyncAction';

export const GET_ALL_ICON_URLS = new AsyncAction('GET_ALL_ICON_URLS');

export function getAllIconUrls(iconSet = 'forecast', iconSize = 4, contrast = null, baseUrl, authId, secret, stdParameters, verbose, refresh = false) {
	return {
		type: GET_ALL_ICON_URLS.base,
		payload: allIconUrls(iconSet, iconSize, contrast, baseUrl, authId, secret, stdParameters, verbose, refresh)
	};
}

async function allIconUrls(iconSet, iconSize, contrast, baseUrl, authId, secret, stdParameters, verbose, refresh) {
	const op = new IconProvider(baseUrl, authId, secret);
	return await op.getAllIcons(iconSet, iconSize, contrast, stdParameters, verbose, refresh);
}
